import { DateTime } from 'luxon';

import { DateFilter, DateFilterKeys, FilterState, TableState } from '../../hooks/useTableState';
import { DateRangePickerMultipleMonths } from '../DatePicker';

export const DateRangeFilter = <T extends FilterState, K extends DateFilterKeys<T>>(
  filterState: T,
  setDateFilter: TableState<T>['filters']['setDateFilter'],
  key: K,
) =>
  function () {
    const filterWeCareAbout = filterState[key] as DateFilter;

    const onDateFilterSelect = (value: { startDate?: Date; endDate?: Date }) => {
      const startDate = value.startDate ? DateTime.fromJSDate(value.startDate).startOf('day').toJSDate() : undefined;
      const endDate = value.endDate ? DateTime.fromJSDate(value.endDate).endOf('day').toJSDate() : undefined;
      setDateFilter(key, { startDate, endDate });
    };

    return (
      <DateRangePickerMultipleMonths
        onSelection={onDateFilterSelect}
        startDate={filterWeCareAbout.startDate}
        endDate={filterWeCareAbout.endDate}
        monthsShown={1}
      />
    );
  };
